import React from "react";
export const tooltipItems = [
  {
    id: "material",
    target: "materialWeakness",
    title: "Material Weakness",
    col: "col-2",
    content: (
      <>
        <b>Material weaknesses</b>
        <br />
        Inadequate compliance to requirements and/or material weaknesses have
        been identified.
        <br />
        Established processes and/or internal controls must be improved.
        <br />
        Findings considered to be critical which require high attention at
        Global owner level and relevant EVPs.
      </>
    ),
  },
  {
    id: "significant",
    target: "significantWeakness",
    title: "Significant Weakness",
    col: "col-2",
    content: (
      <>
        <b>Significant weaknesses that needs to be improved</b>
        <br />
        Compliance impaired in some areas and/or significant weaknesses have
        been identified.
        <br />
        Established processes and/or internal controls need to be improved.
        <br />
        Significant findings which require attention at Global owner level and
        relevant EVPs.
      </>
    ),
  },
  {
    id: "some",
    target: "someWeakness",
    title: "Some Weakness",
    col: "col-2",
    content: (
      <>
        <b>Some weaknesses that should to be improved</b>
        <br />
        Compliance partially impaired in some areas and/or weaknesses have been
        identified.
        <br />
        Established processes and/or internal controls should be improved.
        <br />
        Recommendations which should require attention at Global owner
        representative level.
      </>
    ),
  },
  {
    id: "limited",
    target: "limitedWeakness",
    title: "No or Limited Weakness",
    col: "col-3",
    content: (
      <>
        <b>No or limited weaknesses</b>
        <br />
        Satisfactory compliance or no/limited weaknesses have been identified
        that are not adequately managed.However, there may be a potential to
        improve efficiency and effectiveness in processes.
        <br />
        Recommendations for valuable improvements may be or have been proposed.
      </>
    ),
  },
];
